import { useQuery } from "@tanstack/react-query";
import type { DataToGetWorkOrders } from "../models/DataToGetWorkOrders";
import { fetchWorkOrders } from "../repositorie/WorkOrdersRepositorie";

export const WORK_ORDERS_QUERY_KEYS = {
	all: ["work-orders"] as const,
	// Key only on the fields that actually affect the query (not firstTime /
	// error / assetSearchName, which would cause needless refetches).
	list: (p: DataToGetWorkOrders) =>
		[
			"work-orders",
			"list",
			{
				AssetId: p.AssetId,
				Start: p.Start,
				End: p.End,
				SearchText: p.SearchText,
				TypeCode: p.TypeCode,
				WorkOrderStatusCode: p.WorkOrderStatusCode,
				CraftId: p.CraftId,
				ShowDownDay: p.ShowDownDay,
			},
		] as const,
};

export const useWorkOrders = (
	params: DataToGetWorkOrders,
	enabled = true,
) => {
	const query = useQuery({
		queryKey: WORK_ORDERS_QUERY_KEYS.list(params),
		queryFn: () => fetchWorkOrders(params),
		enabled,
	});

	return {
		workOrders: query.data ?? [],
		isLoading: query.isLoading,
		error: query.error as Error | null,
	};
};
